// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/sections/home/fatturazione/fatturazione.scss
// module id = 600
// module chunks = 0